import React, { useState } from "react";
import { withRouter } from "react-router";
import Banner from "../../components/common/banner";
import Footer from "../../components/common/footer";
import FaqCard from "../../components/common/faqCard";
import VideoPlayer from "../../components/common/videoPlayer";
import Picture from "../../components/common/picture";
import Modal from 'simple-react-modal';
import styles from "./appPreview.module.scss";

const AppPreview = (props) => {
  // const { location, history } = props;

  const [appImageUrl, setAppImageUrl] = useState('');
  const [showModal, setShowModal] = useState(false);

  const show = (event) => {
    const src = event.target.src;

    setAppImageUrl(src);
    setShowModal(true);
  }
 
  const close = () => {
    setShowModal(false);
  }

  const imageUrl =
    "https://firebasestorage.googleapis.com/v0/b/noosaapp.appspot.com/o/assets%2Fbanner_image_form.png?alt=media";

  const faqStyles = { textAlign: "left" };

  const appImages = [
    "/splash_screen.png",
    "/app_one.png",
    "/app_two.png",
    "/app_three.png",
    "/app_four.png",
    "/app_five.png",
    "/app_six.png",
    "/app_seven.png",
    "/app_eight.png",
  ];

  return (
    <div className={styles.landingPreviewContainer}>
      <Banner
        heading="WTD Noosa"
        imageUrl={imageUrl}
        subHeading="App Preview"
      />
      <div className={styles.landingPreviewBody}>
        <div>
          <FaqCard
            containerAlign={faqStyles}
            question="The Only Noosa App You Need."
          >
            <li>
              <p>
                Your seaside Noosa app is finally here, What To Do Noosa. All
                Noosa, in the palm of your hand! Information in this app comes
                from the business owners/representatives and is maintained by
                them directly. Find what you like, add it to your favorites
                list, always have an answer to the "What do you wanna do?"
                question. <br />
                WTD Noosa will add simplicity to your life, when you need it
                most. <br />
                Noosa has a diverse range of businesses and locations. Now you
                don't have to go to Google to find out everything Noosa has to
                offer you. If you are visiting Noosa, WTD Noosa will have you
                walking around like you are a local, if you are lucky enough to
                live in this paradise, it will only remind you why Noosa is such
                a great place to call home.
              </p>
            </li>
          </FaqCard>
          <FaqCard containerAlign={faqStyles} question="App Images.">
            <li>
              <div className={styles.column}>
                <div className={styles.imageGrid}>
                  {appImages && appImages.length > 0 ? (
                    appImages.map((image, key) => {
                      return (
                        <Picture
                          image={image}
                          align="center"
                          handleShowImage={show}
                          key={`${image}-${key}`}
                          imageAlt={`${key}-${image}`}
                        />
                      );
                    })
                  ) : (
                    <div>No images...</div>
                  )}
                </div>
                <Modal
                  onClose={close}
                  show={showModal}
                  closeOnOuterClick={true}
                  containerStyle={{ width: `${550}px` }}
                  style={{ background: "white", cursor: "pointer" }}
                >
                  <img
                    alt="preview"
                    src={appImageUrl}
                    style={{ cursor: "default" }}
                  />
                </Modal>
              </div>
            </li>
          </FaqCard>
          <hr color="lightgrey" />
          <FaqCard containerAlign={faqStyles} question="Your Favourites.">
            <li>
              <VideoPlayer
                url="https://www.youtube.com/watch?v=oU49e595jCM"
                imageUrl=""
                videoTitle=""
                videoDescription="Save your favorites and easily find them later."
                withModal
                playListID="PLzJF8cm6FEKqFf6qGkSiBHM0o5SPxiLC0"
              />
            </li>
          </FaqCard>
          <hr color="lightgrey" />
          <FaqCard containerAlign={faqStyles} question="Explore Noosa.">
            <li>
              <VideoPlayer
                url="https://www.youtube.com/watch?v=phqp8DmE6Z8"
                imageUrl=""
                videoTitle=""
                videoDescription="Easily Explore with WTD Noosa."
                withModal
                playListID="PLzJF8cm6FEKqFf6qGkSiBHM0o5SPxiLC0"
              />
            </li>
          </FaqCard>
          <hr color="lightgrey" />
          <FaqCard containerAlign={faqStyles} question="Get The Info.">
            <li>
              <VideoPlayer
                url="https://www.youtube.com/watch?v=dY5m3HKNjIg"
                imageUrl=""
                videoTitle=""
                videoDescription="Easily get the info and make it happen."
                withModal
                playListID="PLzJF8cm6FEKqFf6qGkSiBHM0o5SPxiLC0"
              />
            </li>
          </FaqCard>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default withRouter(AppPreview);
